import axios from "@/axios";
import { RestoreDto, ResponseMessage } from "@/types";

export async function RestorePost(dto: RestoreDto) {
  const { data } = await axios.post<ResponseMessage<string>>("/auth/restore", dto);
  return data;
}
